let _pendingLazyLoads: number = 0

// Wrap the promise returned by a dynamic import() to refresh the page if it
// fails with a ChunkLoadError in a production build. Track some state in
// sessionStorage so that if we'd enter a refresh loop we instead show the
// loading spinner forever.
export async function refreshImportOnce<T>(modulePromise: Promise<T>): Promise<T> {
  ++_pendingLazyLoads
  let success: boolean = true
  const storageKey = 'import-fail-refresh-status'
  try {
    return await modulePromise
  } catch (e: any) {
    success = false
    if (e.name === 'ChunkLoadError') {  // error name from webpack's JsonpChunkLoadingRuntimeModule.js
      // Try once to refresh. Only skip if we're already in a refresh cycle.
      if (window.sessionStorage.getItem(storageKey) !== 'refreshing') {
        window.sessionStorage.setItem(storageKey, 'refreshing')
        window.location.reload()
      }
      // Mask error by returning a promise that never resolves.
      // This way, clicking on a nav entry that depends on a broken chunk
      // shows an unending loading spinner rather than blanking the whole page.
      return new Promise(() => {})
    }
    throw e  // pass other kinds of errors through
  } finally {
    if (success) {
      if (--_pendingLazyLoads == 0) {
        window.sessionStorage.setItem(storageKey, 'ok')
      }
    }
  }
}

// like refreshImportOnce but skip straight to the unending loading spinner
export async function stallIfChunkLoadError<T>(modulePromise: Promise<T>): Promise<T> {
  try {
    return await modulePromise
  } catch (e: any) {
    if (e.name === 'ChunkLoadError') {
      return new Promise(() => {})
    }
    throw e
  }
}
